import React, { useRef } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
export default function TpStudioHeader({ setOpen, open }) {
  const userInfo = useSelector((state) => state.userStore);

  const username = userInfo.data?.uname ?? "";
  const balance = Math.round(userInfo.data?.bz_balance ?? 0);
  const expouser = Math.round(
    (userInfo.data?.opin_bal ?? 0) - (userInfo.data?.bz_balance ?? 0)
  );

  const formatTruncate = (value) => {
    let num = Math.round(value);
    const truncated = Math.floor(num * 1000) / 1000;

    return new Intl.NumberFormat("en-US", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 3
    }).format(truncated);
  };

  return (
    <div
      className="home-content"
      style={{ minHeight: "60px", background: "#000", marginTop: "-5px" }}
    >
      <style>{`  
      .right-side-wrapper-row{
   background: rgba(0,0,0,0.85);   /* overlay, image still visible */
}
      .main-wrapper {
  background:#000;
}

     .opensidebar {
    left: 0px !important;
}
.right-side-dropdowns-menu ul.dropdown-menu li a:Hover {
    background-color: #c61a1b;
    color: #fff;
}

.menu-content-left-top{
    padding-left: 30px;
}

.lobby-btn {
    align-items: center;
    background-color: initial;
    border: 1px solid #cf8d2e;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    height: 50px !important;
    justify-content: space-evenly;
    width: 47px !important;
}

.lobby-name {
    color: #fff;
    font-family: Montserrat-Bold;
    font-size: 12px !important;
    margin: 0;
}

.exposure-balance-ctn {
    align-items: center;
    background: #191919;
    border: 1.2px solid #cf8d2e;
    border-radius: 6px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    min-width: 100px;
}

.exp-bal {
    color: white;
}

.designation {
    display: inline-block;
    vertical-align: top;
    color: #fff;
    font-weight: 800 !important;
    font-size: 18px
}

/* sidebar */
.wrapper .sidebar {
    margin-top: 80px;
    background: black;
    position: absolute;
    top: 0;
    left: -250px;
    width: 225px;
    height: 90%;
    padding: 20px 0;
    transition: all 0.5s ease;
    z-index: 1010;
} 

.sidebar-content {
    overflow-y: auto;
    max-height: 100%; 
}

.sidebar-content::-webkit-scrollbar {
    display: none;
}

.sidebar-content {
    scrollbar-width: thin;
    scrollbar-color: transparent transparent;
}

.sidebar-content {
    -ms-overflow-style: none;
}

.wrapper .sidebar .profile {
    margin-bottom: 30px;
    text-align: center;
}

.wrapper .sidebar .profile img {
    display: block;
    width: 175px;
    height: auto;
    border-radius: 18%;
    margin: 0 auto;
}



.wrapper .sidebar ul li a {
    display: block;
    padding: 18px 18px;
    border-bottom: 1px solid #10558d;
    color: rgb(241, 237, 237);
    font-size: 16px;
    position: relative;
}

.wrapper .sidebar ul li a .icon {
    color: #dee4ec;
    width: 30px;
    display: inline-block;
}

.wrapper .sidebar ul li a:hover,
.wrapper .sidebar ul li a.active {
    color: #0c7db1;
    background: white;
    border-right: 2px solid rgb(5, 68, 104);
}

.wrapper .sidebar ul li a:hover .icon,
.wrapper .sidebar ul li a.active .icon {
    color: #0c7db1;
}

.wrapper .sidebar ul li a:hover:before,
.wrapper .sidebar ul li a.active:before {
    display: block;
}
/* sidebar */

.table-box-header2 {
    /* background: #254466; */
    padding: 10px;
    margin-bottom: 0;
    padding-bottom: 5px;
    padding-top:5px;
    background: linear-gradient(180deg, #464646, #0f0f0f);
    border: 2px solid;
    border-image-slice: 1 !important;
    border-image-source: linear-gradient(180deg, rgba(207, 141, 46, .47), #cf8d2e 50%, rgba(207, 141, 46, .47));
   
}

.btn-primary2 {
    color: #fff;
    background-color: #00b181;
    border-color: #00b181;
}

.bbactive{
      background-color: black;
}

#videos{
    padding-top:20px !important;
}
.resultDiv{
    margin-left: 0;
    margin-right: 0;
    background: #282828 !important;
    border: 2px solid;
    border-image-slice: 1 !important;
    border-image-source: linear-gradient(180deg, rgba(207, 141, 46, .47), #cf8d2e 50%, rgba(207, 141, 46, .47));
    display: flex;
    flex-direction: row;
    justify-content: space-between;
}
.results-div{
    background: #282828 !important;
    /*border: 2px solid;
    border-image-slice: 1 !important;
    border-image-source: linear-gradient(180deg, rgba(207, 141, 46, .47), #cf8d2e 50%, rgba(207, 141, 46, .47));
    width:60%*/
}
.round-div {
    margin-right: 4px;
    align-items: left;
    color: white;
    display: flex;
    flex-direction: column;
    font-size: 10px;
    justify-content: center;
}

.market-name-icon img{
    margin-top: -1px;
    filter: unset !important;
}

.market-name-icon-aaa img{
    margin-top: -1px !important;
    filter: unset !important;
}
.market-name-icon-aaa img{
    margin-top: -7px !important;
}

#bookmakerExample .btn-block{
    padding: 3px;
    padding-left: 10px;
}

#ResultsData .cards {
    border-width: 1px;
    border-style: solid;
    padding: 5px;
    background-color: #f8f8f8;
    border-color: #dbdbdb;
}

#ResultsData .cardsText {
    font-size: 10px;
    color: #000;
    font-weight: bold;
    text-align: center;
    padding-top: 2px;
    padding-bottom: 4px;
}
#ResultsData .img {
    width: 60px;
}

.sussesBg{
    background:#b7f775 !important;
}
.runner-disabled2{
    width: 377px;
    line-height: 45px;
    color: #f00;
    text-align: center;
    background: #ececed;
    text-transform: uppercase;
    position:absolute;
    z-index:1;
    line-height: 51px;
}
@media screen and (max-width: 768px) {
    .mobh-hide{
        display:none;
    }
    .menu-content-left-top{
        padding-left: 0px;
    }

    .exposure-balance-ctn {
        margin-top: 12px;
        margin-right: 10px;
    }

    #ResultsData .img {
        width: 30px;
    }

    .runner-disabled2 {
        width: 127px;
    }
}

#casinoBetslipPopup .modal-content{
    background-color: transparent !important;
    border:none !important;
}

.dicegame .container {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 10px;
}
.diceofresults {
    width: 75px;
    height: 75px;
    border: 1px solid black;
    border-radius: 15px;
    margin: 0px 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 45px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
    color: red;
}

#AlltabData .clippable-spacer{
    font-weight:600;
}

.sus_cls{
    line-height: 25px !important;
}
#AvxSoundcontrol{
    width: 0px;
    top: 92%;
    margin-right: 8px;
    position: absolute;
    right: 20px;
    font-size: 16px;
    cursor: pointer;
}
`}</style>

      <div className="menu-content-left-top" style={{ width: "33%" }}>
        <div
          className="menu-btn"
          onClick={() => {
            setOpen(!open);
          }}
          style={{
            color: "white",
            fontSize: "x-large",
            cursor: "pointer",
            marginRight: "0px",
            marginLeft: "7px",
            padding: "0px",
            display: open ? "" : "none"
          }}
        >
          ✖
        </div>
        <button
          onClick={() => setOpen(!open)}
          style={{
            padding: "0px",
            background: "transparent",
            border: "none",
            outline: "none",
            boxShadow: "none",
            marginLeft: "0px",
            marginRight: "0px",
            display: open ? "none" : ""
          }}
        >
          <i className="bx bx-menu-new"></i>
        </button>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <ul className="top-nav" style={{ paddingLeft: "25px" }}>
          <li>
            <Link
              className="nav-link"
              to="/tp-studio"
              style={{ textDecoration: "none" }}
            >
              <button className="lobby-btn">
                <img
                  src="/assets/images/tpstudio/lobby-icon.svg"
                  alt="lobby-icon"
                />
                <p className="lobby-name">Lobby</p>
              </button>
            </Link>
          </li>
        </ul>
      </div>

      <div className="header-tickercontainer mobh-hide" style={{ width: "33%" }}>
        <img
          src="/assets/images/tpstudio/tpslogo.png"
          style={{ width: "180px", maxHeight: "60px" }}
          alt="Casino Image"
        />
      </div>
      <div className="right-side-dropdowns-menu">
        <div className="dropdown-right-side">
          <div className="exposure-balance-ctn">
            <img
              src="/assets/images/tpstudio/exposure-icon.svg"
              alt="exposure-icon"
              className="exp-icon"
            />
            <div className="exp-bal">
              <div className="balance-ctn">
                <div className="designation">
                  <span className="wallet-balance">
                    B: Rs.{" "}
                    <span id="span_left_bal">{formatTruncate(balance)}</span>
                  </span>

                  <span className="wallet-exposure">
                    {" "}
                    | L:{" "}
                    <span id="span_strip_exp">
                      <span style={{ display: expouser != 0 ? "" : "none" }}>
                        -
                      </span>
                      {formatTruncate(expouser)}
                    </span>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <audio id="TpbgSound">
        <source src="/assets/images/TpbgSound.mp3" type="audio/mpeg" />
      </audio>
    </div>
  );
}
